import { Component, Input, OnInit } from '@angular/core';

const schema = {
  emailIn: /email\.in/i,
  norSent: /nor\.sent/i,
  phoneIn: /call\.in/i,
  phoneOut: /call\.(out|dialer)/i,
  close: /deleted/i,
  chat: /call|dispute|login/i,
  mail: /mail/i,
  money: /(payment|plan)/i,
  sms: /reachtel|sms/i,
  lorry: /created/i,
};

@Component({
  selector: 'app-activity-icon',
  templateUrl: './activity-icon.component.html',
})
export class ActivityIconComponent implements OnInit {

  @Input() description: string;

  lorry: boolean;
  chat: boolean;
  money: boolean;
  close: boolean;

  ngOnInit() {
    for (let key in schema){
      if (schema[key].test(this.description)) {
        this[key] = true;
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity-icon/activity-icon.component.ts